require('./reportsController');

'use strict';

angular.module('app.admin.reports', [
    'app.admin.reports.reportsController',
]).config([
    '$stateProvider',
    function ($stateProvider) {
        $stateProvider.state('app.admin.reports', {
            url: '/reporting',
            templateUrl: 'components/admin/reports/reportsView.html',
            controller: 'app.admin.reports.reportsController',
            title: 'Reporting'
        });
    }
]);


// WEBPACK FOOTER //
// ./app.v2/components/admin/reports/reports.js